var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrackFlight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.6611 7.99713H13.0084C12.7171 7.99651 12.4337 8.0913 12.2014 8.26701C11.9692 8.44272 11.8008 8.68967 11.7222 8.97009L10.1561 14.5413C10.146 14.5759 10.125 14.6063 10.0961 14.6279C10.0673 14.6496 10.0322 14.6613 9.99619 14.6613C9.96014 14.6613 9.92506 14.6496 9.89623 14.6279C9.86739 14.6063 9.84634 14.5759 9.83625 14.5413L6.15765 1.45296C6.14756 1.41836 6.12651 1.38796 6.09767 1.36633C6.06884 1.3447 6.03376 1.33301 5.99771 1.33301C5.96166 1.33301 5.92659 1.3447 5.89775 1.36633C5.86891 1.38796 5.84787 1.41836 5.83777 1.45296L4.2717 7.02417C4.19338 7.3035 4.02605 7.54965 3.79513 7.72525C3.5642 7.90084 3.28229 7.9963 2.99219 7.99713H1.33282",
    stroke: "#155DFC",
    strokeWidth: 1.33282,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9939,
    height: 15.9939,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrackFlight);
export default __webpack_public_path__ + "static/media/trackFlight.90479c0e0423940dfe3c47e44974d938.svg";
export { ForwardRef as ReactComponent };